/* eslint-disable no-inline-comments */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { BLOCKED_ROUTES, APP_ROUTES } from 'src/app/routes/routes.constants'

function validURL(str) {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
  )

  return Boolean(pattern.test(str))
}

export const DEFAULT_ROUTE = APP_ROUTES.root
export const DATA_NAME = 'lastRoute'
export const useLastRoute = () => {
  const location = useLocation()

  useEffect(() => {
    if (!BLOCKED_ROUTES.includes(location?.pathname)) {
      const theRoute = `${location.pathname}${location.search}`.replace(/\*/gi, '')

      localStorage.setItem(DATA_NAME, theRoute)
    }
  }, [location.pathname])
}

export const redirectLastRoute = () => {
  let lastRoute = localStorage.getItem(DATA_NAME)

  if (!lastRoute || !validURL(`${location.origin}${lastRoute}`)) {
    lastRoute = DEFAULT_ROUTE
  }

  return lastRoute
}
